import { workspaceIconComponent } from './workspaceIconMap'
import { WORKSPACE_EMOJIS } from './workspacePresets'

function asEmoji(value) {
  const text = String(value || '').trim()
  if (!text) return ''
  if (WORKSPACE_EMOJIS.includes(text)) return text
  return /\p{Extended_Pictographic}/u.test(text) ? text : ''
}

export function workspaceVisual(workspace) {
  const glyph = asEmoji(workspace?.emoji) || asEmoji(workspace?.icon)
  if (glyph) return { kind: 'emoji', value: glyph }
  return { kind: 'icon', Icon: workspaceIconComponent(workspace?.icon, 16) }
}
